var newsletterSubmit = {
  phoneInput: $('#call_request_phoneNumber'),
  submitButton: $('#call_request_submit'),
  phoneNumberError: $('#phone-number-call-error'),
  phoneError: false,

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';

    var app = this;
    this.submitButton.on('click', function (event) {
      $('.error-messages').remove();
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        if (!app.phoneError && app.checkPhoneInput()) {
          $('.error-messages').remove();
          app.submitForm(app.form.serialize());
        }
      }
    });
    this.phoneInput.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, '').replace('420', ''));
      if ($(this).val().length > 9) {
        app.phoneNumberError.removeClass('is-hidden');
        app.phoneError = true;
      } else {
        app.phoneNumberError.addClass('is-hidden');
        app.phoneError = false;
      }
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok) {
          // app.showMessage(response.message, 'success');

          // app.submitButton.closest('.modal').removeClass('is-open');
          // $('body').removeClass('is-unscrollable');
          window.location.replace(response.redirectUrl);
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkPhoneInput: function () {
    if (this.phoneInput.val().length !== 9) {
      this.phoneNumberError.removeClass('is-hidden');
      this.phoneError = true;

      return false;
    } else {
      this.phoneNumberError.addClass('is-hidden');
      this.phoneError = false;

      return true;
    }
  },
};

$(function () {
  newsletterSubmit.init();
});
